import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginRegister.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!email || !password) {
      setError("Bitte geben Sie sowohl E-Mail als auch Passwort ein.");
      return;
    }
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
  
      const data = await response.json();
  
    if (response.ok) {
      // Speichern der Benutzerdaten im localStorage
      localStorage.setItem("authToken", data.token);
      localStorage.setItem("user_id", data.user.id);

      // PROFILSTATUS SPEICHERN (WICHTIG FÜR PROTECTED ROUTE)
      localStorage.setItem("profileIncomplete", data.profileIncomplete);

      // Weiterleitung basierend auf Profilstatus
      if (data.profileIncomplete) {
        navigate("/register-user");
      } else {
        navigate("/dashboard");
      }
    }
 else {
        setError(data.message || "Login fehlgeschlagen.");
      }
    } catch (err) {
      setError("Es gab ein Problem beim Login.");
      console.error("Login Error:", err);
    }
  };

  return (
    <div className="register-container">
      <h2 className="register-header">Login</h2>
      {error && <p className="error-message">{error}</p>}
      <form className="register-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">E-Mail</label>
          <input
            type="text"
            id="email"
            name="email"
            className="form-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Passwort</label>
          <input
            type="password"
            id="password"
            name="password"
            className="form-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <div>
          <button type="submit" className="register-button">Login</button>
        </div>
      </form>

      <p className="small-text">
        Noch keinen Account?{" "}
        <a href="/register" className="text-blue-500 hover:underline">Registriere dich hier</a>
      </p>
    </div>
  );
};

export default Login;
